import { render, staticRenderFns } from "./AppCookiePolicyManagerOptionSwitcher.vue?vue&type=template&id=394b0f5b&scoped=true&"
import script from "./AppCookiePolicyManagerOptionSwitcher.vue?vue&type=script&lang=js&"
export * from "./AppCookiePolicyManagerOptionSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AppCookiePolicyManagerOptionSwitcher.vue?vue&type=style&index=0&id=394b0f5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b0f5b",
  null
  
)

export default component.exports